import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { opsProposalEndpoints } from '@/lib/api/endpoints';
import { opsProposalKeys } from '@/lib/queryKeys';
import { estimateKeys } from '@/lib/queryKeys';

interface MaterializeResult {
  proposal: { id: string; [key: string]: unknown };
  estimate: { id: string; [key: string]: unknown };
}

/**
 * Materializes a proposal into an estimate via the operations microservice.
 */
export function useMaterializeProposal() {
  const queryClient = useQueryClient();

  return useApiMutation<MaterializeResult, string>({
    mutationFn: (id) =>
      apiPost<MaterializeResult>(operationsClient, opsProposalEndpoints.materialize(id)),
    onSuccess: (_data, id) => {
      void queryClient.invalidateQueries({ queryKey: opsProposalKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: opsProposalKeys.detail(id) });
      void queryClient.invalidateQueries({ queryKey: estimateKeys.lists() });
      toast.success('Estimate created from proposal');
    },
  });
}
